/*
 * @Author: your name
 * @Date: 2021-08-23 15:09:20
 * @LastEditTime: 2021-08-23 18:11:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \booksnote\src\utils\auth.js
 */
const TokenKey = 'token'
const UserKey = 'userInfo'

export const GET_TOKEN = function() {
  return window.localStorage.getItem(TokenKey)
}

export const SET_TOKEN = function(data) {
  if (!data) return
  return window.localStorage.setItem(TokenKey, data)
}

export const REMOVE_TOKEN = function() {
  window.localStorage.removeItem(UserKey)
  return window.localStorage.removeItem(TokenKey)
}

export const SET_USER = function(data) {
  if (!data) return
  return window.localStorage.setItem(UserKey, JSON.stringify(data))
}

export const GET_USER = function() {
  const userData = window.localStorage.getItem(UserKey)
  return userData ? JSON.parse(userData) : {}
}
